import { LOCAL_STORAGE_KEYS } from 'constant/localStorage';
import { JWTPayload } from 'types/token';

/**
 * Decodes the JWT access token stored in localStorage and returns its payload.
 * Returns null when no token exists or when the token is malformed — callers
 * are responsible for deciding what to do (e.g. treat as expired). Side effects
 * such as redirects must NOT live here.
 */
const Decode = (): JWTPayload | null => {
  try {
    const token = localStorage.getItem(LOCAL_STORAGE_KEYS.TOKEN);
    if (!token) return null;
    return JSON.parse(atob(token.split('.')[1])) as JWTPayload;
  } catch {
    return null;
  }
};

export default Decode;
